export const IS_PROD = process.env.REACT_APP_ENV === 'production'

export const FIREBASE_CONFIG_PROD = {
  apiKey: 'AIzaSyAi3McyL-PqKOOquH55Va1fLNXbmOYDgio',
  authDomain: 'echocheques-prod.firebaseapp.com',
  databaseURL: 'https://echocheques-prod.firebaseio.com',
  projectId: 'echocheques-prod',
  storageBucket: 'echocheques-prod.appspot.com',
  messagingSenderId: '206968322359',
  appId: '1:206968322359:web:a04862a05426114d5b82b2',
  measurementId: 'G-B9L5TGB9ZF',
}

export const FIREBASE_CONFIG_DEV = {
  apiKey: 'AIzaSyCFlRS4MhuhhtQ7M0Mh56qDIZTZexiON3k',
  authDomain: 'echocheques-dev.firebaseapp.com',
  databaseURL: 'https://echocheques-dev.firebaseio.com',
  projectId: 'echocheques-dev',
  storageBucket: 'echocheques-dev.appspot.com',
  messagingSenderId: '757824033502',
  appId: '1:757824033502:web:bbf54e2dcdda5debb3284f',
  measurementId: 'G-VPDKYE9GSN',
}

export const ECHOCHEQUES_CLIENT_ID = 'cdm1NOczCKNBqxCtyOai'

export const FIREBASE_CONFIG = IS_PROD ? FIREBASE_CONFIG_PROD : FIREBASE_CONFIG_DEV

export const ROLE = {
  PRO: 'pro',
  ADMIN: 'admin',
  REGULAR: 'regular',
}

export const DRAWER_WIDTH = 250

export const ROUTES = {
  HOME: '/',
  USER: '/user',
  ORDER: '/order',
  MARKET: '/shop',
  REFUND: '/refund',
}

export const LIST_TYPE = {
  USERS: 'users',
  ORDERS: 'orders',
  MARKETS: 'markets',
  REFUNDS: 'refunds',
  TRANSACTIONS: 'transactions',
}

export const MARKET_CATEGORIES = [
  'shop',
]

export const URL = {
  HOME: '/',
}

export const IS_ADMIN = process.env.REACT_APP_SITE_ENV === 'admin'

export const IS_SHOP = process.env.REACT_APP_SITE_ENV === 'shop'
